import { Dialog, DialogContent, DialogHeader, DialogFooter } from '@/shared/ui/dialog';
import { Button } from '@/shared/ui/button';
import { useTranslation } from '@/shared/i18n';

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  receivableId: string;
  onConfirm: () => void;
  isDeleting: boolean;
}

export function ReceivableDeleteDialog({ open, onOpenChange, receivableId, onConfirm, isDeleting }: Props) {
  const { t } = useTranslation('receivables');
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>{t('deleteReceivable')}</DialogHeader>
        <div>{t('deleteReceivableMessage')} <span className="font-mono">{receivableId}</span>?</div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={isDeleting}>{t('cancel')}</Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? t('deleteReceivableDeleting') : t('deleteReceivableConfirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
